import React from "react";
import Search from "../ui/shared/Search";
import MoreFilter from "../ui/shared/MoreFilter";
import AddNewAssistentes from "./AddNewAssistentes";
import { useTranslation } from "react-i18next";

const FilterHeader: React.FC = () => {
  const { t } = useTranslation("assistants");

  return (
    <div className="w-full mt-3 sm:mt-4 flex-wrap gap-3 flex justify-between items-center">
      <div className="flex items-center gap-2 flex-wrap">
        <Search
          placeholder={t("common.search")}
          styles="w-[170px] sm:w-[220px] md:w-[270px] xl:w-[417px] min-h-[40px]"
        />
        <MoreFilter />
      </div>
      <AddNewAssistentes />
    </div>
  );
};

export default FilterHeader;
